"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionPrice = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const getFontSize = (length, isMobile) => {
    switch (length) {
        case 6:
            return isMobile ? '34px' : '64px';
        case 7:
            return isMobile ? '28px' : '54px';
        case 8:
            return isMobile ? '24px' : '50px';
        case 9:
        case 10:
            return isMobile ? '22px' : '42px';
        case 11:
        case 12:
        case 13:
        case 14:
            return isMobile ? '22px' : '35px';
        case 20:
            return isMobile ? '12px' : '16px';
        default:
            return isMobile ? '34px' : '76px';
    }
};
function SubscriptionPrice({ license, isMobile, t, isValidLicense, }) {
    var _a, _b, _c, _d, _e, _f;
    const price = (_c = (_b = (_a = license.product) === null || _a === void 0 ? void 0 : _a.offer) === null || _b === void 0 ? void 0 : _b.price) !== null && _c !== void 0 ? _c : (_d = license.product) === null || _d === void 0 ? void 0 : _d.price;
    const digits = (_f = (_e = price === null || price === void 0 ? void 0 : price.formattedValuePrefix) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0;
    if (!isValidLicense || !price) {
        return ((0, jsx_runtime_1.jsx)(Price, { length: 20, isMobile: isMobile, isValidLicense: false, "data-e2e": 'SubscriptionPrice_Price', children: t(i18n_1.Strings.store.loadingPrice) }));
    }
    return ((0, jsx_runtime_1.jsxs)(PriceContainer, { "data-e2e": 'SubscriptionPrice_PriceContainer', children: [(0, jsx_runtime_1.jsx)(Price, { length: digits, isMobile: isMobile, isValidLicense: isValidLicense, "data-e2e": 'SubscriptionPrice_Price', children: price.formattedValuePrefix }), (0, jsx_runtime_1.jsx)(PriceType, { "data-e2e": 'SubscriptionPrice_PriceType', children: price.formattedValueSuffixIncludingSeparator
                    ? price.formattedValueSuffixIncludingSeparator
                    : '' })] }));
}
exports.SubscriptionPrice = SubscriptionPrice;
const PriceContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  max-width: 100%;
`;
const Price = styled_components_1.default.div `
  display: contents;
  max-width: 100%;
  height: 80px;

  overflow: hidden;
  white-space: nowrap;

  align-content: center;
  color: #17242a;
  font-size: ${({ length, isMobile }) => getFontSize(length, isMobile)};

  text-align: center;

  ${({ isMobile }) => isMobile && `height: 48px;`}

  ${({ isValidLicense }) => !isValidLicense &&
    `
      color: #a2a7aa;
      font-style: italic;
  `}
`;
const PriceType = styled_components_1.default.div `
  margin-left: 4px;

  color: #4b4f55;

  font-size: 18px;
  text-align: left;
`;
